import { render, staticRenderFns } from "./authReward.vue?vue&type=template&id=32020c20&scoped=true"
import script from "./authReward.vue?vue&type=script&lang=js"
export * from "./authReward.vue?vue&type=script&lang=js"
import style0 from "./authReward.vue?vue&type=style&index=0&id=32020c20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32020c20",
  null
  
)

export default component.exports